import { useParams, Link } from "react-router-dom";

/**
 * UserChildrenPage - Admin page to view all children for a user.
 */
export function UserChildrenPage() {
  const { profileId } = useParams<{ profileId: string }>();

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">User's Children</h1>
          <p className="mt-1 text-sm text-gray-500 font-mono">
            Parent: {profileId}
          </p>
        </div>
        <Link
          to={`/admin/users/${profileId}`}
          className="
            px-4 py-2 text-sm font-medium
            text-gray-700 bg-white border border-gray-200 rounded-lg
            hover:bg-gray-50 transition-colors
          "
        >
          ← Back to User
        </Link>
      </div>

      {/* Children list */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="text-sm text-gray-500 text-center py-12 border-2 border-dashed border-gray-200 rounded-lg">
          <EmptyIcon />
          <p className="mt-2">No children profiles found for this user</p>
        </div>
      </div>
    </div>
  );
}

function EmptyIcon() {
  return (
    <svg
      className="w-12 h-12 text-gray-300 mx-auto"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  );
}

export default UserChildrenPage;
